class AppScripts {
  constructor(container, customerEmail, customerFirstName, customerLastName) {
    this.AppScripts = container;

    this._init();
  }

  _init() {
    this._setEvents();
    this._setloggedOutEvents();
    // this._renderCustomElements();
  }
  _setloggedOutEvents() {
    let isLoggedOut = document
      .querySelector("html")
      .classList.contains("customer-guest");

    if (isLoggedOut) {
      const cookiesToDelete = [
        "swym-email",
        "swym-pid",
        "swym-shutm",
        "swym-swymRegid",
      ];
      const domain = window.location.hostname.replace(/^www\./, ""); // remove www if present
      cookiesToDelete.forEach((cookieName) => {
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${domain}`;
      });
    }
  }

  _setEvents() {}
}
